import { useEffect } from 'react'

const PIXEL_ID = '1322788416056310'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

/**
 * Loads the Meta (Facebook) Pixel base code, initializes it with the
 * project's Pixel ID and fires the initial PageView event.
 *
 * Mirrors the official Meta Pixel snippet but runs client-side from React.
 * Guarded so the loader only runs once even across re-renders / HMR.
 */
export function useMetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return
    if (window.fbq) {
      // Already initialized — just register a PageView.
      window.fbq('track', 'PageView')
      return
    }

    /* eslint-disable */
    // Official Meta Pixel base code.
    ;(function (f: any, b: Document, e: string, v: string) {
      if (f.fbq) return
      const n: any = (f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      })
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []
      const t = b.createElement(e) as HTMLScriptElement
      t.async = true
      t.src = v
      // The original snippet inserts before the first <script>. In sandboxed
      // previews there may be none, so fall back to <head>/<body>.
      const s = b.getElementsByTagName(e)[0]
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s)
      } else {
        ;(b.head || b.body || b.documentElement).appendChild(t)
      }
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )
    /* eslint-enable */

    window.fbq('init', PIXEL_ID)
    window.fbq('track', 'PageView')
  }, [])
}
